import { mixClasses } from './utilities';

export const computeOrderTotal = (items = [], useItemPrice = false) => {
    return items.reduce((total, item) => {
        const price = Number(useItemPrice ? item.price : item.product.price);
        const quantity = Number(item.quantity);
        return total + price * quantity;
    }, 0);
};

export const computeCategories = (items = []) => {
    return items.reduce((categories, item) => {
        item.product.categories.forEach((productCategory) => {
            if (categories.some((category) => category.name === productCategory.name)) {
                // If exists update quantity
                categories = categories.map((category) =>
                    category.name === productCategory.name
                        ? { ...category, quantity: category.quantity + item.quantity }
                        : category
                );
            } else {
                // Else push new category
                categories = [
                    ...categories,
                    { name: productCategory.name, quantity: item.quantity }
                ];
            }
        });
        return categories;
    }, []);
};

export const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
        case 'open':
            return 'warning';
        case 'paid':
            return 'success';
        case 'cancelled':
            return 'danger';
        case 'closed':
            return 'secondary';
        default:
            return 'secondary';
    }
};

export const getOrderComponentClassNames = (order, showChildRow = false) => {
    const itemClassName = mixClasses(['list-group-item', showChildRow ? `bg-secondary` : '']);

    const labelClassName = mixClasses([
        'my-1',
        'fw-bold',
        'd-block',
        'd-lg-none',
        `text-${showChildRow ? 'light' : 'dark'}`
    ]);

    const badgeClassName = mixClasses([
        'badge',
        'rounded-pill',
        showChildRow ? 'text-dark' : '',
        `bg-${showChildRow ? 'light' : getStatusColor(order.status)}`
    ]);

    const textStartClassName = mixClasses([
        'my-1',
        'text-start',
        `text-${showChildRow ? 'light' : 'muted'}`
    ]);

    const textEndClassName = mixClasses([
        'my-1',
        'w-100',
        'text-end',
        `text-${showChildRow ? 'light' : 'muted'}`
    ]);

    const secondaryButtonClassName = mixClasses([
        'btn',
        'btn-sm',
        `btn-outline-${showChildRow ? 'light' : 'secondary'}`
    ]);

    const primaryButtonClassName = mixClasses([
        'btn',
        'btn-sm',
        `btn-outline-${showChildRow ? 'light' : 'primary'}`,
        'ms-2'
    ]);

    return {
        itemClassName,
        labelClassName,
        badgeClassName,
        textStartClassName,
        textEndClassName,
        secondaryButtonClassName,
        primaryButtonClassName
    };
};
